<template>
  <div class="container-fluid shadow header">
    <div class="col-4 wht-text pl-0">
      <a href="https://getmxd.com">
        <img src="../assets/mxd-white.svg" style="width: 126px" alt="MXD Logo" /></a>
    </div>
    <div
      class="col-4 site-nav-primary d-xl-flex justify-content-center align-items-center d-lg-flex d-sm-none d-xs-none d-none">
      <ul class="d-flex justify-content-center align-items-center m-0 p-0">
        <li><a href="https://getmxd.com">Overview</a></li>
        <li><a href="https://getmxdstg.wpenginepowered.com/pricing">Pricing</a></li>
        <li><a href="https://getmxd.com/process">Process</a></li>
      </ul>
    </div>
    <div class="col-4 site-nav-right flex-row d-flex text-right p-0 d-flex justify-content-end align-items-center">
      <div class="mr-2">
        <router-link as="li" to="/cart">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" class="bi bi-cart"
            viewBox="0 0 16 16">
            <path
              d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <span class='badge badge-warning' id='lblCartCount'> {{ cartItemsCount }} </span>
        </router-link>
      </div>

      <div>
        <img class="rounded-circle site-logo" src="../assets/avatar.jpg" height="40" width="40" alt="" />
      </div>

      <div class="dropdown show">
        <p class="nav-header btn btn-secondary dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ userDetails }}
        </p>

        <div v-if="loggedIn" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <router-link class="wht-text nav-text dropdown-item" :to="{ name: 'dashboard' }">Dashboard</router-link>
          <a class="wht-text nav-text dropdown-item" href="https://www.getmxd.com/help" target="_blank">Help</a>
          <router-link class="wht-text nav-text dropdown-item" :to="{ name: 'logout' }">Logout</router-link>
        </div>

        <div v-if="!loggedIn" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <router-link class="wht-text nav-text dropdown-item" :to="{ name: 'login' }">Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cartItemsCount() {
      return this.$store.state.cart.items.length;
    },
    loggedIn() {
      return this.$store.state.apiEvents.jwt != "" ? 1 : 0;
    },
    userDetails() {
      return this.$store.state.apiEvents.username
        ? this.$store.state.apiEvents.username.split("@")[0]
        : "";
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  flex-wrap: nowrap;
  place-content: center;
  align-items: center;
  width: 90%;
  min-height: 160px;
  max-width: 1300px;
}

.site-logo {
  flex: 1 1 0%;
  margin-right: auto;
}

.site-nav-primary {
  flex: 1 1 0%;
}

.site-nav-primary ul li {
  text-decoration: none;
  list-style-type: none;
  margin: 0 20px;
}

.site-nav-primary ul li a {
  display: block;
  font-family: "Astronoma", sans-serif;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 0.9375em;
  letter-spacing: 1.67px;
  border-bottom: 2px solid transparent;
  padding: 12px 0 7px 0;
  -ms-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.site-nav-primary ul li a:hover {
  border-color: #2bfed1;
}

.site-nav-right {
  flex: 1 1 0%;
  margin-left: auto;
}

.nav-header {
  font-size: 15px !important;
  color: rgb(43, 254, 209) !important;
}

.nav-text {
  width: 66px;
  height: 20px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.83px;
}

#lblCartCount {
  font-size: 12px;
  background: rgb(100, 100, 100);
  color: #fff;
  padding: 3px 5px;
  vertical-align: top;
  margin-left: -10px;
}

.badge {
  cursor: pointer;
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}
</style>
